import { PropsWithChildren, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { PageLoader } from '../components/page-loader';
import { CognitoProvider } from './cognito-provider';

export function AppProvider({ children }: PropsWithChildren) {
  return (
    <Suspense fallback={<PageLoader />}>
      <CognitoProvider>
        <BrowserRouter>{children}</BrowserRouter>
      </CognitoProvider>
    </Suspense>
  );
}
